import React, { useState } from 'react';
import { Box, Typography, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, TextField, Alert, Snackbar } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { format } from 'date-fns';

const initialRows = [
  { name: '', details: '', weight: '' },
  { name: '', details: '', weight: '' },
  { name: '', details: '', weight: '' },
  { name: '', details: '', weight: '' },
  { name: '', details: '', weight: '' },
];

const summaryLabels = [
  '22K Total',
  'Convert 24K',
  'Total Weight',
  'Main Balance',
  'Final Balance',
];

const TransactionTotalBalance = () => {
  const [rows, setRows] = useState(initialRows);
  const [rows2, setRows2] = useState(initialRows);
  const [summary, setSummary] = useState(Array(5).fill(''));
  const [saveSuccess, setSaveSuccess] = useState(false);
  const currentDate = new Date();

  const handleRowChange = (rowIdx, field, value) => {
    setRows(rows => rows.map((row, idx) => idx === rowIdx ? { ...row, [field]: value } : row));
  };

  const handleRow2Change = (rowIdx, field, value) => {
    setRows2(rows => rows.map((row, idx) => idx === rowIdx ? { ...row, [field]: value } : row));
  };

  const handleSummaryChange = (idx, value) => {
    // If 22K Total (idx 0) changes, update Convert 24K (idx 1) automatically
    if (idx === 0) {
      const num = parseFloat(value) || 0;
      setSummary(values => {
        const updated = values.map((v, i) => i === 0 ? value : v);
        updated[1] = num ? (num / 0.92).toFixed(3) : '';
        return updated;
      });
    } else if (idx !== 1) {
      setSummary(values => values.map((v, i) => i === idx ? value : v));
    }
  };

  const handleSave = () => {
    setSaveSuccess(true);
  };

  // Calculate total weights for both tables
  const totalWeight1 = rows.reduce((sum, row) => sum + (parseFloat(row.weight) || 0), 0);
  const totalWeight2 = rows2.reduce((sum, row) => sum + (parseFloat(row.weight) || 0), 0);

  return (
    <Box sx={{ mt: 8, px: 2 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
        <Button startIcon={<ArrowBackIcon />} onClick={() => window.history.back()} variant="outlined" color="primary" sx={{ mr: 2 }}>
          Back
        </Button>
        <Box sx={{ flex: 1, display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
          <Typography variant="h6" sx={{ textAlign: 'right' }}>
            Date: {format(currentDate, 'dd/MM/yyyy')}
          </Typography>
        </Box>
      </Box>
      {/* Upper Table */}
      <TableContainer component={Paper} sx={{ mb: 2 }}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell sx={{ fontWeight: 600, width: 120 }}>Name</TableCell>
              <TableCell sx={{ fontWeight: 600, width: 300 }}>Details (24K)</TableCell>
              <TableCell sx={{ fontWeight: 600, width: 120 }}>Weight</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, idx) => (
              <TableRow key={idx}>
                <TableCell>
                  <TextField value={row.name} onChange={e => handleRowChange(idx, 'name', e.target.value)} size="small" variant="standard" fullWidth />
                </TableCell>
                <TableCell sx={{ minWidth: 300 }}>
                  <TextField value={row.details} onChange={e => handleRowChange(idx, 'details', e.target.value)} size="small" variant="standard" fullWidth />
                </TableCell>
                <TableCell>
                  <TextField value={row.weight} onChange={e => handleRowChange(idx, 'weight', e.target.value)} size="small" variant="standard" fullWidth />
                </TableCell>
              </TableRow>
            ))}
            {/* Total row for upper table */}
            <TableRow>
              <TableCell sx={{ fontWeight: 700 }}>Total</TableCell>
              <TableCell />
              <TableCell sx={{ fontWeight: 700 }}>{totalWeight1.toFixed(3)}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
      {/* Lower Table (identical to upper) */}
      <TableContainer component={Paper} sx={{ mb: 2 }}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell sx={{ fontWeight: 600, width: 120 }}>Name</TableCell>
              <TableCell sx={{ fontWeight: 600, width: 300 }}>Details (24K)</TableCell>
              <TableCell sx={{ fontWeight: 600, width: 120 }}>Weight</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows2.map((row, idx) => (
              <TableRow key={idx}>
                <TableCell>
                  <TextField value={row.name} onChange={e => handleRow2Change(idx, 'name', e.target.value)} size="small" variant="standard" fullWidth />
                </TableCell>
                <TableCell sx={{ minWidth: 300 }}>
                  <TextField value={row.details} onChange={e => handleRow2Change(idx, 'details', e.target.value)} size="small" variant="standard" fullWidth />
                </TableCell>
                <TableCell>
                  <TextField value={row.weight} onChange={e => handleRow2Change(idx, 'weight', e.target.value)} size="small" variant="standard" fullWidth />
                </TableCell>
              </TableRow>
            ))}
            {/* Total row for lower table */}
            <TableRow>
              <TableCell sx={{ fontWeight: 700 }}>Total</TableCell>
              <TableCell />
              <TableCell sx={{ fontWeight: 700 }}>{totalWeight2.toFixed(3)}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
      {/* Summary Table (now below both main tables) */}
      <TableContainer component={Paper} sx={{ mb: 2, maxWidth: 500, mx: 'auto' }}>
        <Table size="small">
          <TableBody>
            {summaryLabels.map((label, idx) => (
              <TableRow key={label}>
                <TableCell sx={{ width: 120 }} />
                <TableCell sx={{ fontWeight: 600, width: 300 }}>{label}</TableCell>
                <TableCell>
                  <TextField
                    value={idx === 1 ? (summary[0] ? (parseFloat(summary[0]) / 0.92).toFixed(3) : '') : summary[idx]}
                    onChange={e => handleSummaryChange(idx, e.target.value)}
                    size="small"
                    variant="standard"
                    fullWidth
                    InputProps={idx === 1 ? { readOnly: true } : {}}
                    sx={{ minWidth: 180 }}
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Box sx={{ mt: 2, textAlign: 'right' }}>
        <Button variant="contained" color="primary" onClick={handleSave}>
          Save Transaction
        </Button>
      </Box>
      <Snackbar open={saveSuccess} autoHideDuration={3000} onClose={() => setSaveSuccess(false)} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
        <Alert onClose={() => setSaveSuccess(false)} severity="success" sx={{ width: '100%' }}>
          Transaction saved successfully!
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default TransactionTotalBalance; 